type PatientDocument = 'id' | 'idCard' | 'drivingLicence' | 'passport';

export const PATIENT_DOCUMENTS: { [key in PatientDocument]: number } = {
  id: 0,
  idCard: 1,
  drivingLicence: 2,
  passport: 3,
};
